export default {
  title: {
    index: 'AI Chatbot Management'
  },
  menu: 'AI Chatbot Management',
  btn: {
    uploadAvatar: 'Upload Chatbot Avatar',
    addAction: 'Add Quick Replies',
    deleteAction: 'Delete Quick Replies'
  },
  label: {
    pageDescription: 'Configure the Chatbot display info, prompts, and model settings.',
    basicConfig: 'Basic Configuration',
    triggerConfig: 'Nudge Configuration',
    avatar: 'Chatbot Avatar',
    avatarTip: 'Please upload a jpg/jpeg/png/gif file, less than 2MB.',
    name: 'Chatbot Name (EN)',
    nameCn: 'Chatbot Name (CN)',
    welcomeMessage: 'Welcome Message (EN)',
    welcomeMessageCn: 'Welcome Message (CN)',
    themeColor: 'Theme Color',
    welcomeTrigger: 'Nudge - First Visit ',
    welcomeBackTrigger: 'Nudge - Revisit the same job page',
    stay30sTrigger: 'Nudge - Stay for 30s',
    enabled: 'Enabled',
    messageZh: 'Send a Message (CN)',
    messageEn: 'Send a Message (EN)',
    actionConfig: 'Quick Replies Configuration',
    actionIndex: 'Quick Replies {index}',
    actionLabelZh: 'Button Label (ZH)',
    actionLabelEn: 'Button Label (EN)',
    actionType: 'Button Type',
    actionValue: 'Button Value'
  },
  placeholder: {
    themeColor: 'Please input a hex code, e.g. #1677FF.',
    actionLabelZh: 'Please input a Chinese button label',
    actionLabelEn: 'Please input a English button label',
    actionType: 'Please select a button type',
    actionValueInput: 'Please input a button value',
    actionValueSelect: 'Please select a button value',
    messageZh: 'Please input a Chinese message',
    messageEn: 'Please input a English message'
  },
  option: {
    sendChatbotMessage: 'Send a Message',
    linkRedirection: 'Redirect to',
    applyJob: 'Apply Job'
  },
  message: {
    actionLimit: 'You can add up to {max} quick replies to this nudge.',
    invalidThemeColor: 'Please input a valid hex code.',
    triggerMessageRequired: 'This field is required.',
    triggerActionLabelRequired: 'This field is required.',
    triggerActionValueRequired: 'This field is required.',
    triggerActionUnsupported: 'Error occurs, please check the button type or button value.'
  }
}
